 <template>
  <div id="app" class="wrap">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
</script>


<style>

body {
  background-color: #ececec !important; 
}

.wrap {
    height: auto;
    margin: 0 auto -80px; /* footer height + space */
    min-height: 100%;
    padding: 0 0 0px; /* footer height + space */
    box-sizing: border-box;
    /* overflow: auto; */
}

label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
  font-size: 12px;
}

table {
  font-size: 14px;
}

.form-control {
  font-size: 12px !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.wizard-header {
  display: none !important;
}


</style>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("login", ["loggedIn"])
  }
};
</script>